import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

/**
 * Returns counts from Redux. Accumulation (merge rather than replace) is handled
 * at dispatch time via mergeCounts in searchSlice, so these counts never shrink
 * while the user is on the same location. They reset when the location changes.
 */
export const useCumulativeCounts = () => {
  const { counts, amenities } = useSelector((state: RootState) => state.search);
  return { counts, amenities };
};
